/**
 * @generated SignedSource<<daf3d11ad30f1668f3ad40d01e9f2d8d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetNotePageBackground_widgetNotePage$data = {
  readonly backgroundColor: string | null;
  readonly containImage: boolean | null;
  readonly image: {
    readonly id: string;
    readonly largeImage: {
      readonly height: number;
      readonly url: string;
      readonly width: number;
    } | null;
  } | null;
  readonly imageScale: number | null;
  readonly imageTranslateX: number | null;
  readonly imageTranslateY: number | null;
  readonly remoteImageURL: string | null;
  readonly " $fragmentType": "WidgetNotePageBackground_widgetNotePage";
};
export type WidgetNotePageBackground_widgetNotePage$key = {
  readonly " $data"?: WidgetNotePageBackground_widgetNotePage$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetNotePageBackground_widgetNotePage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetNotePageBackground_widgetNotePage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": "largeImage",
          "args": [
            {
              "kind": "Literal",
              "name": "minHeight",
              "value": 1080
            },
            {
              "kind": "Literal",
              "name": "minWidth",
              "value": 1080
            }
          ],
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "size",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": "size(minHeight:1080,minWidth:1080)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageScale",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageTranslateX",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageTranslateY",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remoteImageURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "containImage",
      "storageKey": null
    }
  ],
  "type": "WidgetNotePage",
  "abstractKey": null
};

(node as any).hash = "4de2bf213c451e946528d6bd2634e462";

export default node;
